import moment from 'moment';
import { DATE_FORMAT, TIME_FORMAT } from '../config/constants';

export const getWeekdays = (dates = []) => {
    const weekDays = [];
    if (dates && dates.length) {
        let count = 0;
        const addedDays = [];
        dates.some(({ date: { date }, startTime, endTime }) => {
            const weekDate = moment(date);
            const weekDay = weekDate.format('dd');

            if (!addedDays.includes(weekDay) && count < 7) {
                addedDays.push(weekDay);
                weekDays.push({
                    day: weekDay,
                    date: weekDate,
                    startTime: startTime,
                    endTime: endTime,
                });
                count++;
            } else {
                return true;
            }
        });
    }
    return weekDays;
};

export const isValidTimeFormat = time => {
    return moment(time, TIME_FORMAT, true).isValid();
};

export const isTodayDate = date => {
    return moment(date).format(DATE_FORMAT) === moment().format(DATE_FORMAT);
};

export const updateDateWithTime = (timeString, dateString) => {
    if (timeString) {
        const date = moment(dateString);
        const [hours, minutes] = timeString.split(':');
        date.set('hours', hours);
        date.set('minutes', minutes);
        return formatDateWithTime(date);
    }
};

export const formatDateWithTime = (date) => {
    return `${date.format(DATE_FORMAT)}T${date.format(TIME_FORMAT)}Z`;
}
